import { render, staticRenderFns } from "./sale-invoices.vue?vue&type=template&id=b5581542&scoped=true"
import script from "./sale-invoices.vue?vue&type=script&lang=js"
export * from "./sale-invoices.vue?vue&type=script&lang=js"
import style0 from "./sale-invoices.vue?vue&type=style&index=0&id=b5581542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5581542",
  null
  
)

export default component.exports